export const homeObjOne = {
  lightBg: true,
  lightText: false,
  lightTopLine: false,
  lightTextDesc: false,
  topLine: 'Get Our Newsletter',
  headline: 'Receive FCHO news',
  description:
    'FCHO provides you with news on all up coming events, also access to hockey news and give aways.',
  buttonLabel: 'Sign Up',
  imgStart: '',
  img: require('../../images/FCHO_1.png').default,
  alt: 'Credit Card'
};
